var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 2.25V7.23938L13.4972 9.12375L9.28012 2.25Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 2.25L5.0625 9.12375L9.28012 7.23938V2.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 12.3569V15.7471L13.5 9.90894L9.28012 12.3569Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 15.7471V12.3564L5.0625 9.90894L9.28012 15.7471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 11.5723L13.4972 9.12373L9.28012 7.24048V11.5723Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 9.12373L9.28012 11.5723V7.24048L5.0625 9.12373Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.d975d2aef2f668fda416379436d40de8.svg";
export { ForwardRef as ReactComponent };